import { aliareApi } from '@/config/appAPIs'
import type { ConfirmEmailType, NewPasswordProps } from '@/types/types'

type SegmentAliare = {
  id: string
  description: string
}

class AliareService {
  tenantsPath: string = 'api/Tenant'
  peoplePath: string = 'api/People'

  constructor() {}

  async getTenants() {
    const response = await aliareApi.tenant.get(this.tenantsPath)

    return response
  }

  async sendNewPassword(data: NewPasswordProps) {
    return await aliareApi.users.post(`/aliare-auth/api/User/CreatePassword`, data)
  }

  async confirmEmail(data: ConfirmEmailType) {
    return await aliareApi.users.post(`/aliare-auth/api/User/ConfirmEmail`, data)
  }

  async getSegments() {
    const result = (await aliareApi.users.get(`aliare-backoffice/api/v1/Segment`)) as any
    return (result || []) as SegmentAliare[]
  }

  async authenticatePortalAliare() {
    try {
      return await aliareApi.portal.post('/api/Login')
    } catch (error) {
      console.log({error});
    }
  }
}

const aliareService = new AliareService()

export default aliareService
